
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/assessment/litnum",
      function () {
        return require("private-next-pages/assessment/litnum/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/assessment/litnum"])
      });
    }
  